import { Injectable, inject } from '@angular/core';
import { CoreActions } from '@next/core-lib';
import { ofType, Actions, createEffect } from '@ngrx/effects';
import { select, Store } from '@ngrx/store';
import { finalize, map, startWith, switchMap, withLatestFrom } from 'rxjs/operators';

import { getCropYear } from 'src/app/store/selectors';

import {
  SalesOrderPeriodActionTypes,
  SetPastSalesOrderPeriods,
  SetSalesOrderPeriods,
} from './sales-order-period.actions';
import { SalesOrderPeriodState } from '../models/sales-order-period.models';
import { SalesOrderPeriodApiService } from '../services/sales-order-period-api.service';

@Injectable()
export class SalesOrderPeriodEffects {
  protected store = inject<Store<SalesOrderPeriodState>>(Store);
  protected actions$ = inject(Actions);
  private readonly api = inject(SalesOrderPeriodApiService);

  getSalesOrderPeriods$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SalesOrderPeriodActionTypes.GetSalesOrderPeriods),
      withLatestFrom(this.store.pipe(select(getCropYear))),
      switchMap(([_, cropYear]) =>
        this.api.getSalesOrderPeriods(cropYear).pipe(
          map((salesOrderPeriods) => new SetSalesOrderPeriods(salesOrderPeriods)),
          finalize(() => this.store.dispatch(CoreActions.setLoading({ loading: false }))),
          startWith(CoreActions.setLoading({ loading: true })),
        ),
      ),
    ),
  );

  getPastSalesOrderPeriods$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SalesOrderPeriodActionTypes.GetPastSalesOrderPeriods),
      withLatestFrom(this.store.pipe(select(getCropYear))),
      switchMap(([_, cropYear]) =>
        this.api.getSalesOrderPeriods(cropYear - 1).pipe(
          map((salesOrderPeriods) => new SetPastSalesOrderPeriods(salesOrderPeriods)),
          finalize(() => this.store.dispatch(CoreActions.setLoading({ loading: false }))),
          startWith(CoreActions.setLoading({ loading: true })),
        ),
      ),
    ),
  );
}
